import _taggedTemplateLiteral from "/home/opc/is-monorepo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  mutation InsertEventLog($cond: EventLogInput) {\n    insertEventLog(condition: $cond)\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
import gql from 'graphql-tag';
export var InsertEventLogMutation = gql(_templateObject());